import Api from '../Api.js';
import BaseView from './_BaseView.js';
import Confirm from '../components/Confirm.js';
import FileImport from '../components/FileImport.js';

export default class LanguageView extends BaseView {

    init() {

        super.init();
        const self = this;
        $('.js-example-basic-single').select2();
        $('.wysiwyg').trumbowyg({
            removeformatPasted: true,
            fullscreenable: false,
            resetCss: true,
            //autogrow: true,
            height: 100,
            btns: [
                ['viewHTML'],
                ['undo', 'redo'],
                ['formatting'],
                ['foreColor', 'backColor'],
                ['strong', 'em'],
                ['link'],
                ['insertImage'],
                ['justifyLeft', 'justifyCenter', 'justifyRight', 'justifyFull'],
                ['unorderedList', 'orderedList'],
                ['horizontalRule'],
                ['removeformat']
            ]
        });
        if ($("#languagelistGroup").length > 0) {
            const id = $('#guidetitle').data('id');
            const fileImport = new FileImport($('#import-lang'), {
                url: `/api/guides/${id}/importlang`,
                formTpl: 'import-file-form',
                title: 'Language File',
                datalist: $('#language'),
                getFormData: function ($form) {
                    return $form.aeroSerialize();
                }
            });
            fileImport.init();

            self.render('en', id);
        }
    }

    setEvents() {
        const self = this;
        $('#langlist').select2().on('change', function () {
            self.render($('#langlist').val(), $('#guidetitle').data('id'));
        });

        $('.btn.export').on('click', function () {
            const lang = $('#langlist').val();
            const id = $('#guidetitle').data('id');
            const app = $('[data-app]').data('app');
            const plainText = $(this).hasClass('plainText');
            if (plainText) {
                Confirm({
                    ok: Lang.save,
                    title: Lang.guideinfo,
                    msg: 'Are you sure you want to export as plain text?',
                    onConfirm: function () {
                        window.location = `/api/guides/languageexport?app=${app}&lang=${lang}&id=${id}${plainText ? '&plainText=true' : ''}`;
                    }
                });
                return false;
            }
            window.location = `/api/guides/languageexport?app=${app}&lang=${lang}&id=${id}`;
            return false;
        });

        $('#language').on('reload', function () {
            self.render($('#langlist').val(), $('#guidetitle').data('id'));
        });

    }

    render(lang, id) {
        const self = this;
        const $tbody = $('#language tbody');

        Api.send('/api/guides/' + id, {locale: lang}).done(function (guide) {
            $tbody.empty();

            $tbody.append(`<tr class="guide">
                        <td>${Lang.guideinfo}</td>
                        <td>${guide.title}</td>
                        <td>${guide.desc}</td>
                        <td></td>
                        <td></td>
                        <td></td>
                        <td><div class="tools"><a class="btn btn-dark edit-guide"><i class="jsicon-edit"></i> ${Lang.edit}</a></div></td>
                    </tr>`);
            $tbody.find('tr.guide').data('guide', guide);

            // steps
            if (guide.step) {
                for (let i = 0; i < guide.step.length; ++i) {
                    let step = guide.step[i];

                    let answers = [];
                    if (step.answers) {
                        for (let j = 0; j < step.answers.length; ++j) {
                            answers.push(step.answers[j].title);
                        }
                    }
                    if (step.errmsg) {
                        answers.push(step.errmsg);
                    }

                    let alerts = [step.alert, step.alertContent, step.lossalert, step.lossalertContent]
                        .filter(content => content.length > 0)
                        .join('<br>');

                    $tbody.append(`<tr class="step">
                        <td>${parseInt(i) + 1}</td>
                        <td>${step.title}</td>
                        <td>${step.body}</td>
                        <td>${answers.join('<br>')}</td>
                        <td>${alerts}</td>
                        <td>${step.loc}</td>
                        <td><div class="tools"><a class="btn btn-dark edit-step" data-index="${i}"><i class="jsicon-edit"></i> ${Lang.edit}</a></div></td>
                    </tr>`);
                }
            }
            self.setTableEvents();
        });
    }

    setTableEvents() {
        const self = this;
        $('.edit-guide').on('click', function () {
            self.editGuide($(this).parents('tbody').find('tr.guide').data('guide'));
        });
        $('.edit-step').on('click', function () {
            self.editStep($(this).parents('tbody').find('tr.guide').data('guide'), parseInt($(this).data('index')));
        });
    }

    editGuide(guide) {
        const self = this;
        let method = 'patch';
        let url = `/api/guides/${guide.id}`;

        Api.getTpl('lang-guide-form').done(function (r) {
            const tpl = _.template(r);
            let olddata = {title: guide.title, body: guide.desc};

            Confirm({
                ok: Lang.save,
                title: Lang.guideinfo,
                msg: tpl({step: olddata}),
                classes: 'large-modal allow-enter',
                onValidate: function () {
                    return $('#langForm').isFormValid();
                },
                onConfirm: function () {

                    const data = $('#langForm').aeroSerialize();
                    guide.title = data.title;
                    guide.desc = data.body;
                    guide.locale = $('#langlist').val();

                    // remove host since it conflicts with CheckHost and current instance
                    delete guide.host;
                    Api.send(url, guide, method).done(function () {
                        self.render($('#langlist').val(), guide.id);
                    });

                }
            });
        });
    }

    editStep(guide, stepIndex) {
        const self = this;
        const step = guide.step[stepIndex];
        Api.getTpl('lang-guide-form').done(function (r) {
            const tpl = _.template(r);

            let classes = 'large-modal allow-enter';

            const data = {
                title: step.title,
                body: step.body,
                answers: step.answers ? step.answers : [],
                errmsg: step.errmsg ? step.errmsg : '',
                alert: step.alert ? step.alert : '',
                alertContent: step.alertContent ? step.alertContent : '',
                lossalert: step.lossalert ? step.lossalert : '',
                lossalertContent: step.lossalertContent ? step.lossalertContent : ''
            };

            if (data.answers.length +
                data.errmsg.length +
                data.alert.length +
                data.alertContent.length +
                data.lossalert.length +
                data.lossalertContent.length > 0) {
                data.extras = true;
                classes = 'larger-modal allow-enter';
            }

            Confirm({
                ok: Lang.save,
                title: Lang.guideinfo,
                classes: classes,
                msg: tpl({step: data}),
                onValidate: function () {
                    return $('#langForm').isFormValid();
                },
                onConfirm: function () {
                    const input = $('#langForm').aeroSerialize();
                    input.active = !!(data.active);
                    input.id = guide._id;
                    input.index = stepIndex;
                    // update the titles in the next step
                    input.answers = step.answers;
                    $('input.answer').each(function (i) {
                        step.answers[i].title = $(this).val();
                    });
                    self.saveStep(input, $('#langlist').val());
                }
            });
        });
    }

    saveStep(step, lang) {
        const self = this;
        step.locale = lang;

        Api.send('/api/steps', step, 'patch').done(function () {
            self.render($('#langlist').val(), $('#guidetitle').data('id'));
        });
    }
}
